export default __webpack_public_path__ + "static/media/IMG_0371.94d2d85b.PNG";